// extracted by mini-css-extract-plugin
module.exports = {"grid":"CraftEditor_grid__2MwGT","column":"CraftEditor_column__1bl8g","tab":"CraftEditor_tab__a-aHb","segment":"CraftEditor_segment__3vAeI"};